/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_appsync_graphqlEndpoint": "https://37gu2ppsajclvf7gbcjfjbw7h4.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-4yha6o47lbgyzncdmf7xjffcdy",
    "aws_cognito_identity_pool_id": "us-east-1:ba884934-c84f-4946-8407-09f77ada0571",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_6bep3adis",
    "aws_user_pools_web_client_id": "6oce98fs9gdnhlo15c9tu7lngr",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OPTIONAL",
    "aws_cognito_mfa_types": [
        "TOTP"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "platformd9531187bef34a10abb664f2878180ae00db6-internal",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
